import React from "react";
import { LotDispositionUpdatesInformationTable } from "../../entities/lot-disposition-updates-information/lot-disposition-updates-information-table";

export function LotDispositionUpdatesInformationPage(props) {
  return <LotDispositionUpdatesInformationTable {...props} />;
}
